import React from 'react';
import {
  Home,
  Bungalow,
  Apartment,
  Domain,
  HolidayVillage,
  ViewModule,
  LocationCity,
  CorporateFare,
  Business,
  MapsHomeWork,
  Hub,
  Engineering,
  Landscape,
  Terrain,
  Park,
  WorkspacePremium,
  People,
  Groups,
  Badge,
  Store,
  HomeWork,
  SupervisorAccount,
  AdminPanelSettings,
  BusinessCenter,
  Construction,
  Diversity3,
  Handshake,
  AccountBalance,
  Factory,
  SvgIconComponent,
} from '@mui/icons-material';

/** Ícones válidos para planos (configuráveis no admin / condoCapacityPacks) */
export const PACKAGE_ICON_MAP: Record<string, SvgIconComponent> = {
  Home,
  Bungalow,
  Apartment,
  Domain,
  HolidayVillage,
  ViewModule,
  LocationCity,
  CorporateFare,
  Business,
  MapsHomeWork,
  Hub,
  Engineering,
  Landscape,
  Terrain,
  Park,
  WorkspacePremium,
  People,
  Groups,
  Badge,
  Store,
  HomeWork,
  SupervisorAccount,
  AdminPanelSettings,
  BusinessCenter,
  Construction,
  Diversity3,
  Handshake,
  AccountBalance,
  Factory,
};

interface PackageIconProps {
  iconName?: string | null;
  fallback?: SvgIconComponent;
  sx?: object;
}

const PackageIcon: React.FC<PackageIconProps> = ({
  iconName,
  fallback = WorkspacePremium,
  sx = {},
}) => {
  const icon = iconName && typeof iconName === 'string' ? String(iconName).trim() : '';
  const ResolvedIcon: SvgIconComponent =
    (icon && PACKAGE_ICON_MAP[icon]) || fallback || WorkspacePremium;
  return <ResolvedIcon sx={{ fontSize: 36, ...sx }} />;
};

export default PackageIcon;
